import { render, staticRenderFns } from "./notificationsComponent.vue?vue&type=template&id=08dc591e&scoped=true"
import script from "./notificationsComponent.vue?vue&type=script&lang=js"
export * from "./notificationsComponent.vue?vue&type=script&lang=js"
import style0 from "./notificationsComponent.vue?vue&type=style&index=0&id=08dc591e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dc591e",
  null
  
)

export default component.exports